import { createAsyncThunk } from '@reduxjs/toolkit';
import { getGroupColors, getGroupLogo } from 'services/api';
import { GroupColors, GroupLogo } from './constants';

/**
 * Logo efectivo del grupo del usuario logado, para la cabecera. Lo pide la propia cabecera al
 * cambiar de usuario, y la pestaña Logo del detalle de grupo tras subir o quitar uno: cambiar el
 * logo de un ancestro también cambia el del usuario.
 */
export const getHeaderLogoAsync: any | null = createAsyncThunk('groupLogo/getHeader', async (groupId: string) => {
  const response: any = await getGroupLogo(groupId);
  return (response?.data?.item ?? null) as GroupLogo | null;
});

/** Colores de marca efectivos del grupo del usuario logado. Mismo ciclo que el logo de la cabecera. */
export const getHeaderColorsAsync: any | null = createAsyncThunk('groupLogo/getHeaderColors', async (groupId: string) => {
  const response: any = await getGroupColors(groupId);
  return (response?.data?.item ?? null) as GroupColors | null;
});
